import { Injectable } from '@angular/core';
import {
  map, Observable, ReplaySubject, tap
} from 'rxjs';

import { AI_BIO_PROMPT_NAME, IEnhancedBio } from '../models/enhanced-bio.model';
import { EnhancedBioHttpService } from '../services/enhanced-bio.httpservice';

@Injectable({
  providedIn: 'root'
})
export class EnhancedBioStore {
  private activeEnhancedBioSubj = new ReplaySubject<IEnhancedBio | null>(1);
  activeEnhancedBio$ = this.activeEnhancedBioSubj.asObservable();
  private loadedActiveBio: boolean = false;

  constructor(
    private enhancedBioHttpService: EnhancedBioHttpService,
  ) {}

  loadActiveBioByProviderId(personaProviderId: number, forceRefresh: boolean = false): Observable<IEnhancedBio | null> {
    if (this.loadedActiveBio && !forceRefresh) {
      return this.activeEnhancedBio$;
    }

    return this.enhancedBioHttpService.getByProviderId(personaProviderId).pipe(
      map((bios: IEnhancedBio[] | null) => bios || []),
      map((bios: IEnhancedBio[]) => bios.filter((bio) => bio.active)),
      map((activeBios: IEnhancedBio[]) => (activeBios?.length ? activeBios[0] : null)),
      tap((data) => {
        this.loadedActiveBio = true;
        this.activeEnhancedBioSubj.next(data);
      })
    );
  }

  deactivate(bioId: string): Observable<IEnhancedBio | null> {
    return this.enhancedBioHttpService.deactivate(bioId).pipe(
      tap((data) => {
        this.activeEnhancedBioSubj.next(data);
      })
    );
  }

  activate(bioId: string): Observable<IEnhancedBio | null> {
    return this.enhancedBioHttpService.activate(bioId).pipe(
      tap((data) => {
        this.activeEnhancedBioSubj.next(data);
      })
    );
  }

  didProviderOptIn(personaProviderId: number): Observable<boolean> {
    return this.enhancedBioHttpService.getByProviderId(personaProviderId).pipe(
      map((bios: IEnhancedBio[] | null) => {
        if (!bios?.length) return false;
        return bios.some((bio) => bio.providerAccepted === true && bio.promptName === AI_BIO_PROMPT_NAME);
      })
    );
  }
}
